// The Benefit Bay wind-down (2026-10-01): clients of the Benefit Bay (ICHRA)
// employers were soft-deactivated with `deactivated_reason = 'former_ichra'`
// and every surface that can still reach them shows this one message.
// flow/scheduling/coverage.py holds the same string; change both.
// Spec: docs/superpowers/specs/2026-09-24-former-ichra-soft-deactivation-design.md

export const FORMER_ICHRA = 'former_ichra'

export const FORMER_ICHRA_MESSAGE = "Doctor's Choice no longer has a partnership through your employer. Please contact HR for information about the Medicare support options available to you."

// A client record (search result, survey payload, scheduler row) closed by the
// wind-down. False for active clients and for every other inactive one.
export function isFormerIchra (record) {
    return !!record && record.active === false && record.deactivated_reason === FORMER_ICHRA
}
